/* Drop-in for next/image on the ported home page. Renders a plain <img>: `fill`
   becomes the absolute-positioned cover box Next would produce, and the
   Next-only optimisation props are dropped. */
export default function Image({
  fill = false,
  priority = false,
  sizes,
  quality,
  placeholder,
  blurDataURL,
  unoptimized,
  className = "",
  style,
  alt = "",
  ...rest
}) {
  const cls = fill ? `absolute inset-0 h-full w-full ${className}`.trim() : className;
  return (
    <img
      {...rest}
      alt={alt}
      loading={priority ? "eager" : rest.loading || "lazy"}
      decoding="async"
      className={cls || undefined}
      style={style}
    />
  );
}
